import WebComponent from '../../webComponents/WebComponent.js';
import { replaceParameters } from '../../lib/string';
import prettyBytes from 'pretty-bytes';
// neimportuje se $ protože, chceme kompatibilitu i na webech bez jQuery k jquery se pak musí přistupovat přes window.$, aby se nehádalo popřípadě s jiným jquery na stránce


const FRAGMENTS = {
  ITEM: '[data-fragment="item"]',
  REMOVE: '[data-fragment="remove"]',
  INPUT: '[data-fragment="input"]',
  LIST: '[data-fragment="list"]',
  FILE_ITEM_TEMPLATE: '[data-template="FileItem"]',
};


class FileInput extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: [],
    };
    this.handleAfterServerValidation = this.handleAfterServerValidation.bind(this);
  }

  didMount() {
    this.on('click', FRAGMENTS.REMOVE, this.handleRemoveClick);
    this.on('change', FRAGMENTS.INPUT, this.handleChange);

    this.setState({
      value: this.elements.INPUT.files,
    });
    this.template = this.element.querySelector(FRAGMENTS.FILE_ITEM_TEMPLATE).innerHTML;
    this.name = this.elements.INPUT.getAttribute('name');
    this.nameWithoutFrm = this.name.replace(/^frm\./, '');
    this.form = this.element.closest('form');
    if (this.form && window.$) {
      this.form.addEventListener('afterServerValidation', this.handleAfterServerValidation);
    }
    // this.on('change', FRAGMENTS.INPUT, this.handleInputEventChange);
  }
  handleAfterServerValidation(e, result) {
    const {value} = this.state;
    // client side validation for File Size
    if (value) {
      const data = result || e.detail.data;
      const totalSize = [...value].reduce((previousValue, currentValue) => previousValue + currentValue.size, 0);
      const widgetValidationResult = data.widgets[this.nameWithoutFrm];

      if (!widgetValidationResult.hasErrors && this.props.fileSizeMax != null && totalSize >= this.props.fileSizeMax) {
        const newWidgetValidationResult = {
          ...widgetValidationResult,
          hasErrors: true,
          hasValidators: true,
          messages: `<p class="formGroup_message formGroup_message__error" id="${widgetValidationResult.widgetMessageId}" role="alert">${replaceParameters(this.props.messages.multiFileSize, { 0: this.props.label, 1: '0 B', 2: prettyBytes(this.props.fileSizeMax, { binary: true }).replace('MiB', 'MB')})}</p>`,
          hasMessages: true
        }
        // mutable override!
        data.widgets[this.nameWithoutFrm] = newWidgetValidationResult;
      }
    }
  }
  triggerChange = (value) => {
    if (window.$) {
      const liveValidationInstance = window.$(this.form).data('liveValidation');
      if (liveValidationInstance) {
        // validace spouštět vždy
        liveValidationInstance.visitedInputs[this.name] = false;
        window.$(this.elements.INPUT).trigger('requestValidation');
      }
    }

    if (this.props.dispatchChangeEvent) {
      this.dispatchEvent({ type: 'input', value });
      this.dispatchEvent({ type: 'change', value });
      this.setState({
        changed: true,
      });
    }
  }
  handleChange = (e) => {
    this.setState({
      value: e.target.files,
    });
    e.stopPropagation();
    this.triggerChange(e.target.files);
  }
  handleRemoveClick = (e) => {
    const index = parseInt(e.target.closest(FRAGMENTS.ITEM).dataset.index) || 0;
    const newValues = Array.from(this.state.value);
    newValues.splice(index, 1);

    const dt = new DataTransfer()
    newValues.forEach((file) => {
      dt.items.add(file);
    });
    const value = dt.files;
    this.elements.INPUT.files = value;
    this.setState({
      value,
    });
    this.triggerChange(value);
  };

  willUnMount() {

  }
  update(prevProps, prevState, inDocument) {
    this.elements.LIST.innerHTML = [...(this.state.value) || []].map(({ size, type, name, lastModified }, index) => replaceParameters(this.template, { size, type, name, lastModified, index})).join('\n')
  }
}

FileInput.fragments = FRAGMENTS;
FileInput.defaultProps = {

};

export default FileInput;




// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/components/fileInput/FileInput.js